// extracted by mini-css-extract-plugin
module.exports = {"root":"InputSecondary_root__1yGmd","error":"InputSecondary_error__2jRCa","disabled":"InputSecondary_disabled__3Eaoe"};